import * as Constants from "./constants";

export class StorageHelper {
    static setUser(user) {
        localStorage.setItem(Constants.LS_USER_KEY, JSON.stringify(user));
    }

    static getUser() {
        let user = localStorage.getItem(Constants.LS_USER_KEY);
        try {
            return JSON.parse(user);
        } catch (e) {
            console.error("error parsing user");
        }
    }

    static setToken(token) {
        localStorage.setItem(Constants.LS_TOKEN_KEY, token);
    }

    static getToken() {
        return localStorage.getItem(Constants.LS_TOKEN_KEY);
    }

    static setRefreshToken(token) {
        localStorage.setItem(Constants.LS_REFRESH_TOKEN_KEY, token);
    }

    static getRefreshToken() {
        return localStorage.getItem(Constants.LS_REFRESH_TOKEN_KEY);
    }

    static removeToken() {
        return localStorage.removeItem(Constants.LS_TOKEN_KEY);
    }

    static removeRefreshToken() {
        return localStorage.removeItem(Constants.LS_REFRESH_TOKEN_KEY);
    }
}
